module.exports = __webpack_public_path__ + "static/logo2-a732bfb56b8781185691bdb56b4867af.png";